function memo(callback) {
  let result;
  return () => {
    if (result === undefined) result = callback();
    return result;
  };
}
export { memo };